// Click-to-WhatsApp deep links (wa.me) — no WhatsApp Business account required.

/**
 * Normalize a phone to wa.me digits (country code, no +) — but ONLY for numbers
 * WhatsApp can plausibly reach. IT landlines (+39 0xx) and bare foreign numbers
 * with no country code return null, so we never offer a WhatsApp button that
 * can't deliver (anti-teatro). Explicit intl (+ / 00) is trusted.
 */
export function normalizePhoneIntl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  let d = raw.replace(/[^\d+]/g, "");
  if (!d) return null;
  if (d.startsWith("+")) d = d.slice(1);
  else if (d.startsWith("00")) d = d.slice(2);
  else if (d.startsWith("39")) { /* already has IT country code */ }
  else if (/^3\d{8,9}$/.test(d)) d = "39" + d; // bare IT mobile (starts 3, 9–10 digits)
  else return null; // bare landline / ambiguous foreign -> can't WhatsApp safely
  if (!/^\d{8,15}$/.test(d)) return null;
  if (d.startsWith("390")) return null; // IT landline (+39 0xx) -> no WhatsApp
  return d;
}

export function waLink(phone: string | null | undefined, text: string): string | null {
  const n = normalizePhoneIntl(phone);
  return n ? `https://wa.me/${n}?text=${encodeURIComponent(text)}` : null;
}
